import { PortalAccessPanel } from "@components/campaigns/PortalAccessPanel";
import { CAMPAIGN_QUERY } from "@lib/graphql/queries";
import { ArrowLeft } from "lucide-react";
import { useCallback } from "react";
import { Link, useParams } from "react-router";
import { useQuery } from "urql";

export function CampaignSettings() {
  const { id } = useParams();
  const [{ data, fetching }, reexecute] = useQuery({ query: CAMPAIGN_QUERY, variables: { id } });
  const refresh = useCallback(() => reexecute({ requestPolicy: "network-only" }), [reexecute]);
  const campaign = data?.campaign;

  if (fetching) return <p className="text-sm text-text-muted">Loading...</p>;
  if (!campaign) return <p className="text-sm text-text-muted">Campaign not found</p>;

  return (
    <div>
      <Link
        to={`/campaigns/${campaign.id}`}
        className="mb-4 flex items-center gap-1 text-sm text-text-muted hover:text-text-secondary"
      >
        <ArrowLeft size={16} /> Back to campaign
      </Link>

      <div>
        <h1 className="text-2xl font-bold tracking-tight text-text-primary">
          {campaign.title} — Settings
        </h1>
        <p className="mt-1 text-sm text-text-muted">{campaign.client.name}</p>
      </div>

      {/* Tabs */}
      <div className="mt-6 border-b border-border">
        <nav className="-mb-px flex gap-6">
          <button className="border-b-2 border-accent pb-3 text-sm font-medium text-accent transition-colors">
            Portal Access
          </button>
        </nav>
      </div>

      <div className="mt-6">
        <PortalAccessPanel
          campaignId={campaign.id}
          portalUsers={campaign.portalUsers ?? []}
          portalInvitations={campaign.portalInvitations ?? []}
          onRefresh={refresh}
        />
      </div>
    </div>
  );
}
